/**
 * regionProgressReportConverters.js
 *
 * DashboardRegionProgressReportPage から抽出された純粋関数群
 * Region 進捗報告画面固有のデータ変換ロジックを提供
 */

/**
 * マスターデータから選択肢を生成（複数ピッカー対応）
 * @param {Array<Object>} items - マスターデータ配列
 * @param {Array<Function>} pickers - 値を抽出する関数の配列
 * @returns {Array<string>} 選択肢配列（先頭に空文字を含む）
 */
export function buildMasterOptions(items, pickers = []) {
  const values = new Set();
  items.forEach((item) => {
    const value = pickers.map((p) => p(item)).find((v) => v);
    if (value) values.add(value);
  });
  return ['', ...Array.from(values)];
}

/**
 * 進捗報告レコードを表示用行データに変換
 * @param {Object} item - 進捗報告レコード
 * @returns {Object} 表示用行データ
 */
export function displayRow(item) {
  const oemRegionFallback = item.oem || '-';
  const regionFallback = item.region || '-';
  const oemRegion = item.oemRegion || `${oemRegionFallback}-${regionFallback}`;

  return {
    oemRegion,
    reportDate: item.reportDate || '-',
    region: item.region || '-',
    assignee: item.assignee || '-',
    comment: item.comment || '-',
    riskTitle: item.riskTitle || '-',
    problemTitle: item.problemTitle || '-',
  };
}
